import QueryService from "../utils/QueryService.ts";

class FeedbackService {
	private feedback = new QueryService("/feedback/");

	// Unified feedback method
	sendFeedback = (feedbackData: any): Promise<any> => {
		return this.feedback.post("submit", feedbackData);
	};
}

export default FeedbackService;
